import { useRef } from "react";
import { Mesh, MeshStandardMaterialParameters } from "three";
import { useLoader } from "@react-three/fiber";
import { ThreeMFLoader } from "three-stdlib";
import buttonOnSTL from "./../../assets/button_on.3mf";
import buttonOffSTL from "./../../assets/button_off.3mf";
import { Text } from "@react-three/drei";

const LoadButtonOff = ({ onClick }: { onClick: () => void }) => {
  // useFrame(() => {
  const stlRef = useRef<Mesh | null>(null);

  const res = useLoader(ThreeMFLoader, buttonOffSTL);

  const materialProps: MeshStandardMaterialParameters = {
    // color: 0xa0a0a0,
    // metalness: 0.8,
    // roughness: 0.4,
    // emissive: "grey",
    // emissiveIntensity: 0.2,
  };
  // })

  return (
    <mesh
      onClick={onClick}
      receiveShadow
      ref={stlRef}
      scale={[0.03, 0.03, 0.02]}
      position={[10.05, 7, -5.8]}
      rotation={[0, 0, 0]}
    >
      <primitive object={res} />
      <meshStandardMaterial {...materialProps} />
      <Text
        position={[0, -21, 10]}
        fontSize={10}
        color="red"
        anchorX="center"
        anchorY="middle"
        rotation={[0, Math.PI, 0]}
      >
        OFF
      </Text>
    </mesh>
  );
};
const LoadButtonOn = ({ onClick }: { onClick: () => void }) => {
  // useFrame(() => {
  const stlRef = useRef<Mesh | null>(null);

  const res = useLoader(ThreeMFLoader, buttonOnSTL);

  const materialProps: MeshStandardMaterialParameters = {
    // color: 0xa0a0a0,
    // metalness: 0.8,
    // roughness: 0.4,
    // emissive: "grey",
    // emissiveIntensity: 0.2,
  };
  // })

  return (
    <mesh
      onClick={onClick}
      receiveShadow
      ref={stlRef}
      scale={[0.03, 0.03, 0.02]}
      position={[10.05, 7, -5.8]}
      rotation={[0, 0, 0]}
    >
      <primitive object={res} />
      <meshStandardMaterial {...materialProps} />
      <Text
        position={[0, -21, 10]}
        fontSize={10}
        color="green"
        anchorX="center"
        anchorY="middle"
        rotation={[0, Math.PI, 0]}
      >
        ON
      </Text>
    </mesh>
  );
};

const RenderButton = ({
  isConnected,
  onClick,
}: {
  isConnected: boolean;
  onClick: () => void;
}) => {
  return isConnected ? (
    <LoadButtonOn onClick={() => onClick()} />
  ) : (
    <LoadButtonOff onClick={() => onClick()} />
  );
};

export default RenderButton;
